import type { IconSvgObject } from './types';

const JobLinkIcon: IconSvgObject = [
  ["path", { d: "M21 12.5V8C21 6.89543 20.1046 6 19 6H4C2.89543 6 2 6.89543 2 8V19.5C2 20.6046 2.89543 21.5 4 21.5H10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 6L14.7072 3.22528C14.5846 2.79598 14.1922 2.5 13.7457 2.5H9.2543C8.80782 2.5 8.41544 2.79598 8.29278 3.22528L7.5 6", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 18.5H16M16 21.5C14.3431 21.5 13 20.1569 13 18.5C13 16.8431 14.3431 15.5 16 15.5M19 21.5C20.6569 21.5 22 20.1569 22 18.5C22 16.8431 20.6569 15.5 19 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default JobLinkIcon;
